import React, { useState, useEffect } from 'react';
import './fontSizeController.css';

const FontSizeController = () => {
    const [fontSize, setFontSize] = useState('medium');

    useEffect(() => {
        const savedFontSize = localStorage.getItem('fontSizePreference') || 'medium';
        setFontSize(savedFontSize);
        applyFontSize(savedFontSize);
    }, []);

    const applyFontSize = (size) => {
        const root = document.documentElement;
        
        // Remove existing font size classes
        root.classList.remove('font-size-small', 'font-size-medium', 'font-size-large');
        
        // Apply new font size class
        root.classList.add(`font-size-${size}`);
        
        // Save preference to localStorage
        localStorage.setItem('fontSizePreference', size);
    };

    const handleFontSizeChange = (size) => {
        setFontSize(size);
        applyFontSize(size);
    };

    return (
        <div className="font-size-controller" role="toolbar" aria-label="Kontrola rozmiaru czcionki">
            <div className="font-size-buttons">
                <button
                    className={`font-button font-small ${fontSize === 'small' ? 'active' : ''}`}
                    onClick={() => handleFontSizeChange('small')}
                    aria-label="Mała czcionka"
                    title="Mała czcionka"
                >
                    A
                </button>
                <button
                    className={`font-button font-medium ${fontSize === 'medium' ? 'active' : ''}`}
                    onClick={() => handleFontSizeChange('medium')}
                    aria-label="Średnia czcionka"
                    title="Średnia czcionka"
                >
                    A
                </button>
                <button
                    className={`font-button font-large ${fontSize === 'large' ? 'active' : ''}`}
                    onClick={() => handleFontSizeChange('large')}
                    aria-label="Duża czcionka"
                    title="Duża czcionka"
                >
                    A
                </button>
            </div>
        </div>
    );
};

export default FontSizeController;
